import React, { ForwardedRef, MutableRefObject } from 'react';

import {
    AccessibilityRole,
    Platform,
    Pressable,
    View,
    ViewStyle,
} from 'react-native';

import { SvgProps } from 'react-native-svg';

import styles from './styles';

type Props = {
    id?: string;
    Svg: React.ComponentType<SvgProps>;
    style?: any;
    svgStyle?: ViewStyle;
    disabled?: boolean;
    fill?: string;
    onPress?(): void;
    onKeyDownCapture?(event: KeyboardEvent): void;
    tabIndex?: number;
    testID?: string;
    accessible?: boolean;
    accessibilityLabel?: string;
    accessibilityRole?: AccessibilityRole;
    importantForAccessibility?:
        | 'auto'
        | 'yes'
        | 'no'
        | 'no-hide-descendants'
        | undefined;
    accessibilityElementsHidden?: boolean | undefined;
};

function SvgButton(
    {
        id,
        Svg,
        onPress,
        onKeyDownCapture,
        style,
        svgStyle,
        fill,
        disabled = false,
        tabIndex,
        testID,
        accessible,
        accessibilityLabel,
        accessibilityRole = 'button',
        importantForAccessibility = 'auto',
        accessibilityElementsHidden,
    }: Props,
    forwardedRef?: ForwardedRef<View | undefined>,
) {
    const svgButtonRef = forwardedRef as
        | MutableRefObject<View | null>
        | undefined;

    return (
        <Pressable
            testID={testID}
            id={id}
            accessible={accessible}
            accessibilityLabel={accessibilityLabel}
            accessibilityRole={accessibilityRole}
            aria-disabled={disabled}
            importantForAccessibility={importantForAccessibility}
            accessibilityElementsHidden={accessibilityElementsHidden}
            style={({ pressed }) => [
                styles.button,
                { opacity: pressed ? 0.5 : 1 },
                style,
            ]}
            disabled={disabled}
            onPress={onPress}
            {...Platform.select({
                web: {
                    onKeyDownCapture,
                },
            })}
            ref={svgButtonRef}
            // @ts-ignore
            tabIndex={tabIndex}
            android_ripple={{ borderless: true }}
        >
            <Svg
                id="svg-id"
                fill={fill}
                // @ts-ignore
                width={svgStyle?.width || 24}
                // @ts-ignore
                height={svgStyle?.height || 24}
            />
        </Pressable>
    );
}

export default React.forwardRef(SvgButton);
